import React, {useEffect} from 'react';
import styled from 'styled-components';
import {Subheading} from 'app/styles/heading';
import {SIZES} from '@fupa/fupa-uikit';
import {EmbedTeaser} from 'app/components/tv/preview/EmbedTeaser';
import {PlaylistTeaser} from 'app/components/tv/preview/PlaylistTeaser';
import {Skeleton} from '@mui/material';
import {EmbedWrapper} from 'app/components/tv/preview/SharedPreviewStyles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

const TeaserContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: scroll;
  padding-left: ${SIZES['16']};

  // hide scrollbar chrome, safari and opera
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const VideoTeaser = ({videos, videosCount, setVideosCount}) => {
  useEffect(() => {
    if (videos.length) {
      const obj = {...videosCount};
      videos.map(video => {
        if (video.type === 'playlist') {
          obj[video.data.id] = video.data.videosCount;
        }
      });
      setVideosCount(obj);
    }
  }, [videos]);

  const teasers = videos.length ? (
    videos.map(video => {
      const key = video.data.id;
      if (video.type === 'embed') {
        return <EmbedTeaser key={key} video={video} />;
      } else if (video.type === 'playlist') {
        return <PlaylistTeaser key={key} video={video} videosCount={videosCount[video.data.id]} />;
      }
    })
  ) : (
    <Skeleton variant='rounded'>
      <EmbedWrapper />
    </Skeleton>
  );

  return (
    <Wrapper>
      <Subheading variant='subheading2'>Video-Highlights</Subheading>
      <TeaserContainer>{teasers}</TeaserContainer>
    </Wrapper>
  );
};
